module.exports = __webpack_public_path__ + "445f1b5edcf6cf8e522ab5de95669d0d.MP3";